// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProposalCard_ProposalCard__W67CI {
  background-color: var(--white);
  border-radius: 12px;
  border: 1px solid var(--border);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardHead__Z6UQm {
  background-color: var(--bg1);
  padding: 12px 0 12px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardHead__Z6UQm .ProposalCard_ProposalCardHeadLeft__DhNTq {
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  max-width: calc(100% - 150px);
  overflow: hidden;
}
@media screen and (max-width: 450px) {
  .ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardHead__Z6UQm .ProposalCard_ProposalCardHeadLeft__DhNTq {
    flex-direction: column;
    align-items: start;
    width: 100%;
    max-width: 100%;
  }
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardHead__Z6UQm .ProposalCard_ProposalCardHeadLeft__DhNTq figure {
  display: flex;
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardHead__Z6UQm .ProposalCard_ProposalCardHeadLeft__DhNTq figure img {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 50%;
  object-position: center;
  overflow: hidden;
  border: 1px solid var(--border);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardHead__Z6UQm .ProposalCard_ProposalCardResponse__U7kgv {
  width: fit-content;
}
@media screen and (max-width: 450px) {
  .ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardHead__Z6UQm .ProposalCard_ProposalCardResponse__U7kgv {
    position: absolute;
    right: 0;
    top: 16px;
  }
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardHead__Z6UQm .ProposalCard_ProposalCardHeadText__POOPE {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: calc(100% - 45px);
}
@media screen and (max-width: 450px) {
  .ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardHead__Z6UQm .ProposalCard_ProposalCardHeadText__POOPE {
    max-width: calc(100% - 12px);
  }
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardHead__Z6UQm .ProposalCard_ProposalCardHeadText__POOPE h2 {
  font: var(--body-font-two);
  font-weight: 600;
  color: var(--primary-Text);
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardHead__Z6UQm .ProposalCard_ProposalCardHeadText__POOPE .ProposalCard_ProposalCardHeadTextSub__cyeVr {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardHead__Z6UQm .ProposalCard_ProposalCardHeadText__POOPE .ProposalCard_ProposalCardHeadTextSub__cyeVr p {
  font: var(--body-font-four);
  font-weight: 400;
  color: var(--secondary-Text);
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding-left: 8px;
  border-left: 1px solid var(--border);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardHead__Z6UQm .ProposalCard_ProposalCardHeadText__POOPE .ProposalCard_ProposalCardHeadTextSub__cyeVr p:first-child {
  padding-left: 0;
  border-left: 0;
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardHead__Z6UQm .ProposalCard_ProposalCardHeadText__POOPE .ProposalCard_ProposalCardHeadTextSub__cyeVr p img {
  width: 16px;
  height: 16px;
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardBodyMain__U8AxO {
  background-color: var(--white);
  border-top: 1px solid var(--border);
  padding: 12px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardBodyMain__U8AxO .ProposalCard_ProposalCardBody__-ilqy p {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--brand);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardBodyMain__U8AxO .ProposalCard_ProposalCardBody__-ilqy span {
  font: var(--body-font-three);
  font-weight: 400;
  color: var(--secondary-Text);
  display: block;
  margin-top: 4px;
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardBodyMain__U8AxO .ProposalCard_ProposalCardFooter__g7H8E {
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media screen and (max-width: 450px) {
  .ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardBodyMain__U8AxO .ProposalCard_ProposalCardFooter__g7H8E {
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardBodyMain__U8AxO .ProposalCard_ProposalCardFooter__g7H8E p {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardBodyMain__U8AxO .ProposalCard_ProposalCardFooter__g7H8E .ProposalCard_ProposalCardFooterBtn__REPFu {
  display: flex;
  gap: 12px;
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardBodyMain__U8AxO .ProposalCard_ProposalCardFooter__g7H8E .ProposalCard_ProposalCardFooterBtn__REPFu img {
  filter: brightness(0) invert(1);
}
@media screen and (max-width: 450px) {
  .ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardBodyMain__U8AxO .ProposalCard_ProposalCardFooter__g7H8E .ProposalCard_ProposalCardFooterBtn__REPFu {
    width: 100%;
  }
  .ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardBodyMain__U8AxO .ProposalCard_ProposalCardFooter__g7H8E .ProposalCard_ProposalCardFooterBtn__REPFu button {
    width: 100%;
  }
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardStatus__-wJY6 {
  padding: 8px;
  border-radius: 0;
  background-color: var(--bg3);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardStatus__-wJY6.ProposalCard_submitted__dcaHE {
  background-color: var(--bg3);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardStatus__-wJY6.ProposalCard_submitted__dcaHE p {
  color: var(--brand);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardStatus__-wJY6.ProposalCard_submitted__dcaHE p:before {
  background-color: var(--brand);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardStatus__-wJY6.ProposalCard_in-review__WVpZc {
  background-color: #fff5e9;
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardStatus__-wJY6.ProposalCard_in-review__WVpZc p {
  color: var(--warning);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardStatus__-wJY6.ProposalCard_in-review__WVpZc p:before {
  background-color: var(--warning);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardStatus__-wJY6.ProposalCard_approved__jlLYK {
  background-color: #edf7ee;
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardStatus__-wJY6.ProposalCard_approved__jlLYK p {
  color: var(--success);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardStatus__-wJY6.ProposalCard_approved__jlLYK p:before {
  background-color: var(--success);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardStatus__-wJY6.ProposalCard_declined__cNhQe {
  background-color: #feeceb;
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardStatus__-wJY6.ProposalCard_declined__cNhQe p {
  color: var(--error);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardStatus__-wJY6.ProposalCard_declined__cNhQe p:before {
  background-color: var(--error);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardStatus__-wJY6 p {
  font: var(--body-font-four);
  font-weight: 500;
  color: var(--brand);
  position: relative;
  padding-left: 8px;
  text-align: center;
  width: fit-content;
  margin: 0 auto;
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardStatus__-wJY6 p:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: var(--brand);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardPackage__AcXJ5 p {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--brand);
}
.ProposalCard_ProposalCard__W67CI .ProposalCard_ProposalCardPackage__AcXJ5 span {
  font: var(--body-font-three);
  color: var(--secondary-Text);
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/ProposalCard/ProposalCard.module.scss"],"names":[],"mappings":"AAAA;EACC,8BAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AACD;AACC;EACC,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AACF;AAME;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;AAJH;AAMG;EARD;IASE,sBAAA;IACA,kBAAA;IACA,WAAA;IACA,eAAA;EAHF;AACF;AAKG;EACC,aAAA;AAHJ;AAKI;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,+BAAA;AAHL;AAQE;EACC,kBAAA;AANH;AAQG;EAHD;IAKE,kBAAA;IACA,QAAA;IACA,SAAA;EANF;AACF;AASE;EACC,aAAA;EACA,sBAAA;EACA,QAAA;EACA,4BAAA;AAPH;AASG;EAND;IAOE,4BAAA;EANF;AACF;AAQG;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;EAEA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAPJ;AAUG;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AARJ;AAUI;EACC,2BAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EACA,oCAAA;AATL;AAWK;EACC,eAAA;EACA,cAAA;AATN;AAYK;EACC,WAAA;EACA,YAAA;AAVN;AAiBC;EACC,8BAAA;EACA,mCAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AAfF;AAkBG;EACC,4BAAA;EACA,gBAAA;EACA,mBAAA;AAhBJ;AAmBG;EACC,4BAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;EACA,eAAA;AAjBJ;AAqBE;EACC,gBAAA;EACA,iBAAA;EACA,mCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAnBH;AAqBG;EARD;IASE,sBAAA;IACA,SAAA;IACA,kBAAA;EAlBF;AACF;AAoBG;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AAlBJ;AAqBG;EACC,aAAA;EACA,SAAA;AAnBJ;AAqBI;EACC,+BAAA;AAnBL;AAsBI;EARD;IASE,WAAA;EAnBH;EAqBG;IACC,WAAA;EAnBJ;AACF;AAyBC;EACC,YAAA;EACA,gBAAA;EACA,4BAAA;AAvBF;AAyBE;EACC,4BAAA;AAvBH;AAyBG;EACC,mBAAA;AAvBJ;AAyBI;EACC,8BAAA;AAvBL;AA4BE;EACC,yBAAA;AA1BH;AA4BG;EACC,qBAAA;AA1BJ;AA4BI;EACC,gCAAA;AA1BL;AA+BE;EACC,yBAAA;AA7BH;AA+BG;EACC,qBAAA;AA7BJ;AA+BI;EACC,gCAAA;AA7BL;AAkCE;EACC,yBAAA;AAhCH;AAkCG;EACC,mBAAA;AAhCJ;AAkCI;EACC,8BAAA;AAhCL;AAqCE;EACC,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAnCH;AAqCG;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;AAnCJ;AAyCE;EACC,4BAAA;EACA,gBAAA;EACA,mBAAA;AAvCH;AAyCE;EACC,4BAAA;EACA,4BAAA;AAvCH","sourcesContent":[".ProposalCard {\r\n\tbackground-color: var(--white);\r\n\tborder-radius: 12px;\r\n\tborder: 1px solid var(--border);\r\n\toverflow: hidden;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\theight: 100%;\r\n\r\n\t.ProposalCardHead {\r\n\t\tbackground-color: var(--bg1);\r\n\t\tpadding: 12px 0 12px 12px;\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tposition: relative;\r\n\r\n\t\t@media screen and (max-width: 450px) {\r\n\t\t\t// flex-direction: column;\r\n\t\t\t// gap: 16px;\r\n\t\t}\r\n\r\n\t\t.ProposalCardHeadLeft {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 8px;\r\n\t\t\twidth: fit-content;\r\n\t\t\tmax-width: calc(100% - 150px);\r\n\t\t\toverflow: hidden;\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\talign-items: start;\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t}\r\n\r\n\t\t\tfigure {\r\n\t\t\t\tdisplay: flex;\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\twidth: 48px;\r\n\t\t\t\t\theight: 48px;\r\n\t\t\t\t\tobject-fit: cover;\r\n\t\t\t\t\tborder-radius: 50%;\r\n\t\t\t\t\tobject-position: center;\r\n\t\t\t\t\toverflow: hidden;\r\n\t\t\t\t\tborder: 1px solid var(--border);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.ProposalCardResponse {\r\n\t\t\twidth: fit-content;\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\t// width: 100%;\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\tright: 0;\r\n\t\t\t\ttop: 16px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.ProposalCardHeadText {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 4px;\r\n\t\t\tmax-width: calc(100% - 45px);\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\tmax-width: calc(100% - 12px);\r\n\t\t\t}\r\n\r\n\t\t\th2 {\r\n\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\r\n\t\t\t\ttext-overflow: ellipsis;\r\n\t\t\t\toverflow: hidden;\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t\twhite-space: nowrap;\r\n\t\t\t}\r\n\r\n\t\t\t.ProposalCardHeadTextSub {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: start;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 8px;\r\n\t\t\t\tmargin-top: 4px;\r\n\r\n\t\t\t\tp {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tgap: 4px;\r\n\t\t\t\t\tmargin: 0;\r\n\r\n\t\t\t\t\tpadding-left: 8px;\r\n\t\t\t\t\tborder-left: 1px solid var(--border);\r\n\r\n\t\t\t\t\t&:first-child {\r\n\t\t\t\t\t\tpadding-left: 0;\r\n\t\t\t\t\t\tborder-left: 0;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\timg {\r\n\t\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\t\theight: 16px;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.ProposalCardBodyMain {\r\n\t\tbackground-color: var(--white);\r\n\t\tborder-top: 1px solid var(--border);\r\n\t\tpadding: 12px;\r\n\t\tflex: 1;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\r\n\t\t.ProposalCardBody {\r\n\t\t\tp {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 500;\r\n\t\t\t\tcolor: var(--brand);\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 400;\r\n\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\tmargin-top: 4px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.ProposalCardFooter {\r\n\t\t\tmargin-top: auto;\r\n\t\t\tpadding-top: 16px;\r\n\t\t\tborder-top: 1px solid var(--border);\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\tgap: 16px;\r\n\t\t\t\talign-items: start;\r\n\t\t\t}\r\n\r\n\t\t\tp {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t}\r\n\r\n\t\t\t.ProposalCardFooterBtn {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tgap: 12px;\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\tfilter: brightness(0) invert(1);\r\n\t\t\t\t}\r\n\r\n\t\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\t\twidth: 100%;\r\n\r\n\t\t\t\t\tbutton {\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.ProposalCardStatus {\r\n\t\tpadding: 8px;\r\n\t\tborder-radius: 0;\r\n\t\tbackground-color: var(--bg3);\r\n\r\n\t\t&.submitted {\r\n\t\t\tbackground-color: var(--bg3);\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--brand);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--brand);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.in-review {\r\n\t\t\tbackground-color: #fff5e9;\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--warning);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--warning);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.approved {\r\n\t\t\tbackground-color: #edf7ee;\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--success);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--success);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.declined {\r\n\t\t\tbackground-color: #feeceb;\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--error);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--error);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\tp {\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t\tfont-weight: 500;\r\n\t\t\tcolor: var(--brand);\r\n\t\t\tposition: relative;\r\n\t\t\tpadding-left: 8px;\r\n\t\t\ttext-align: center;\r\n\t\t\twidth: fit-content;\r\n\t\t\tmargin: 0 auto;\r\n\r\n\t\t\t&:before {\r\n\t\t\t\tcontent: '';\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\ttop: 50%;\r\n\t\t\t\tleft: 0;\r\n\t\t\t\ttransform: translateY(-50%);\r\n\t\t\t\twidth: 4px;\r\n\t\t\t\theight: 4px;\r\n\t\t\t\tborder-radius: 50%;\r\n\t\t\t\tbackground-color: var(--brand);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.ProposalCardPackage {\r\n\t\tp {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tfont-weight: 500;\r\n\t\t\tcolor: var(--brand);\r\n\t\t}\r\n\t\tspan {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: var(--secondary-Text);\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ProposalCard": `ProposalCard_ProposalCard__W67CI`,
	"ProposalCardHead": `ProposalCard_ProposalCardHead__Z6UQm`,
	"ProposalCardHeadLeft": `ProposalCard_ProposalCardHeadLeft__DhNTq`,
	"ProposalCardResponse": `ProposalCard_ProposalCardResponse__U7kgv`,
	"ProposalCardHeadText": `ProposalCard_ProposalCardHeadText__POOPE`,
	"ProposalCardHeadTextSub": `ProposalCard_ProposalCardHeadTextSub__cyeVr`,
	"ProposalCardBodyMain": `ProposalCard_ProposalCardBodyMain__U8AxO`,
	"ProposalCardBody": `ProposalCard_ProposalCardBody__-ilqy`,
	"ProposalCardFooter": `ProposalCard_ProposalCardFooter__g7H8E`,
	"ProposalCardFooterBtn": `ProposalCard_ProposalCardFooterBtn__REPFu`,
	"ProposalCardStatus": `ProposalCard_ProposalCardStatus__-wJY6`,
	"submitted": `ProposalCard_submitted__dcaHE`,
	"in-review": `ProposalCard_in-review__WVpZc`,
	"approved": `ProposalCard_approved__jlLYK`,
	"declined": `ProposalCard_declined__cNhQe`,
	"ProposalCardPackage": `ProposalCard_ProposalCardPackage__AcXJ5`
};
export default ___CSS_LOADER_EXPORT___;
